document.addEventListener("turbolinks:load", () => {
  $("#select-all-search-term").on("click", () => {
    $('#search-terms-delete-form input[type="checkbox"]').click();
  });
});
